import authReducer from "./authreducer";
import taskReducer from "./taskreducer";
import { combineReducers } from "redux";
import { firestoreReducer } from "redux-firestore";
import { firebaseReducer } from "react-redux-firebase";
const rootReducer = combineReducers({
  auth: authReducer,
  task: taskReducer,
  firestore: firestoreReducer,
  firebase: firebaseReducer,
});

export default rootReducer;
